import React, {
  Dispatch,
  ReactElement, SetStateAction,
} from 'react';
import {
  DatePicker, FormGroup, Label,
} from 'idsk-react-components';
import { ExpansionPanel } from 'slovlex-idsk-react-components';
import './sidePanel.scss';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import SearchInput from './SearchInput';
import InstituciaSingleSelect from './InstituciaSingleSelect';
import NavrhAktuEuFilter from '../../../model/NavrhAktuEuFilter';
import TypSingleSelect from '../../VyhladavaniePravoEu/component/TypSingleSelect';

interface Props {
  filter: NavrhAktuEuFilter;
  onUpdateField: SafeParameterSetter<NavrhAktuEuFilter>;
  filterCopy: NavrhAktuEuFilter;
  onUpdateFieldCopy: SafeParameterSetter<NavrhAktuEuFilter>;
  setFilter: Dispatch<SetStateAction<NavrhAktuEuFilter>>,
}

const MobileFilters = ({
  filter,
  onUpdateField,
  filterCopy,
  onUpdateFieldCopy,
  setFilter,
}: Props): ReactElement => (
  <div className="akt-eu-list-side-panel">
    <ExpansionPanel title="Číslo procesu" className="first-expansion-panel">
      <SearchInput
        filterCopy={filterCopy}
        filterSearchText={filterCopy?.cisloLegislativnehoMaterialu}
        fieldName="cisloLegislativnehoMaterialu"
        onUpdateFieldCopy={onUpdateFieldCopy}
        setFilter={setFilter}
        className="slovlex-idsk-side-panel-input-wrapper"
      />
    </ExpansionPanel>
    <ExpansionPanel title="Identifikátor aktu">
      <SearchInput
        filterCopy={filterCopy}
        filterSearchText={filterCopy?.identifikatorAktu}
        fieldName="identifikatorAktu"
        onUpdateFieldCopy={onUpdateFieldCopy}
        setFilter={setFilter}
        className="slovlex-idsk-side-panel-input-wrapper"
      />
    </ExpansionPanel>
    <ExpansionPanel title="Názov procesu">
      <SearchInput
        filterCopy={filterCopy}
        filterSearchText={filterCopy?.nazovLegislativnehoMaterialu}
        fieldName="nazovLegislativnehoMaterialu"
        onUpdateFieldCopy={onUpdateFieldCopy}
        setFilter={setFilter}
        className="slovlex-idsk-side-panel-input-wrapper"
      />
    </ExpansionPanel>
    <ExpansionPanel title="Názov aktu EÚ">
      <SearchInput
        filterCopy={filterCopy}
        filterSearchText={filterCopy?.nazovAktu}
        fieldName="nazovAktu"
        onUpdateFieldCopy={onUpdateFieldCopy}
        setFilter={setFilter}
        className="slovlex-idsk-side-panel-input-wrapper"
      />
    </ExpansionPanel>
    <ExpansionPanel title="Typ aktu">
      <TypSingleSelect
        onUpdateField={onUpdateField}
        onUpdateFieldCopy={onUpdateFieldCopy}
        filter={filter}
        filterCopy={filterCopy}
        isNavrhAktuEu
      />
    </ExpansionPanel>
    <InstituciaSingleSelect
      onUpdateField={onUpdateField}
      onUpdateFieldCopy={onUpdateFieldCopy}
      filter={filter}
      filterCopy={filterCopy}
    />
    <ExpansionPanel title="Medziinštitucionálny kód">
      <SearchInput
        filterSearchText={filterCopy?.medziinstitucionalnyKod}
        fieldName="medziinstitucionalnyKod"
        onUpdateFieldCopy={onUpdateFieldCopy}
        filterCopy={filterCopy}
        setFilter={setFilter}
      />
    </ExpansionPanel>
    <ExpansionPanel title="Dátum prijatia">
      <FormGroup>
        <FormGroup>
          <Label htmlFor="prijatieOd">Dátum od</Label>
          <DatePicker
            id="prijatieOd"
            showIcon
            value={filter?.datumPrijatiaAktuOd}
            onChange={date => onUpdateField('datumPrijatiaAktuOd', date)}
            strictParsing
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="prijatieOd">Dátum do</Label>
          <DatePicker
            id="prijatieDo"
            showIcon
            value={filter?.datumPrijatiaAktuDo}
            onChange={date => onUpdateField('datumPrijatiaAktuDo', date)}
            strictParsing
          />
        </FormGroup>
      </FormGroup>
    </ExpansionPanel>
  </div>
);

export default MobileFilters;
